<template>
    <div class="event-reschedule">
        <i class="el-icon-date"></i>&nbsp;
        <strong>{{ getContentKey('event', event.matchId, 'name') }}</strong>
        <template v-if="event.isReschedule">
            exists on <strong>{{ formatDate(event.previous_time, true, true) }}</strong>. It will get <strong>rescheduled</strong> to
            <strong>{{ formatDate(event.time, true, true) }}</strong>.
            <el-button type="text" class="create-button" @click="$emit('create', event)" v-if="confirm">
                <CreateEventIcon></CreateEventIcon>
                Create New Event instead
            </el-button>
        </template>
        <template v-else>
            on <strong>{{ formatDate(event.time, true, true) }}</strong>
            <el-button type="text" class="edit-button" @click="$emit('reschedule', event)" v-if="confirm">
                <EditIcon></EditIcon> Reschedule Event from {{ formatDate(event.previous_time, true, true) }}
            </el-button> 
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import formatDate from '@/module/util/format-date'
import Icons from '@/module/add/icons'


export default {
    name: 'event-reschedule',
    props: {
        event: {
            type: Object
        },
        confirm: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters('content', [ 'getContentKey' ]),
    },

    methods: {
        formatDate,
    },
    components: {
        ...Icons
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
.event-reschedule {
    display: inline-block;
}
</style>